<template>

    <div class="company">
        <!-- [ Header ] start -->
        <Header :open="open" @showMenu="showMenu" @hideMenu="hideMenu" />
        <!-- [ Header ] end -->

        <div class="content">

            <!-- [ Menu ] start -->
            <Menu :open="open" @companyName="companyName"/>
            <!-- [ Menu ] end -->

            <div class="wrap">

                <!-- [ Tree ] start -->
                <div class="wrap__tree">

                    <div class="nav-tree">
                        <div>
                            <router-link to="/my-regions">
                                <el-button size="mini" class="nav-tree__item" type="primary" plain>
                                    Regions
                                </el-button>
                            </router-link>
                        </div>
                        <div>
                            <router-link to="/business-centers">
                                <el-button size="mini" class="nav-tree__item" type="primary" plain>
                                    Business Centers
                                </el-button>
                            </router-link>
                        </div>
                        <div>
                            <router-link to="/add-business-units">
                                <el-button size="mini" class="nav-tree__item" type="primary" plain>Business Units</el-button>
                            </router-link>
                        </div>
                    </div>

                    <!-- <ag-grid-vue style="width: 100%; height: 96%;" class="ag-theme-balham" id="myGrid"
                      :gridOptions="gridOptions"
                      @grid-ready="onGridReady"
                      :columnDefs="columnDefs"
                      :defaultColDef="defaultColDef"
                      :rowDragManaged="true"
                      :animateRows="true"
                      :rowData="rowData"
                      :rowSelection="rowSelection"
                      @selection-changed="onSelectionChanged"></ag-grid-vue> -->

                </div>
                <!-- [ Tree ] end -->

                <!-- [ Tree info ] start -->
                <div class="wrap__info">

                    <!-- [ Info ] start -->
                    <div class="wrap__info-tab">
                        <el-tabs type="card">
                            <el-tab-pane label="Info" name="first">
                                <ul>
                                    <li><span>Name:</span></li>
                                    <li><span>Location:</span></li>
                                    <li><span>Phone:</span></li>
                                    <li><span>Fax:</span></li>
                                    <li><span>Email:</span></li>
                                    <li><span>Website:</span></li>
                                    <li><span>Manual:</span></li>
                                    <li><span>Forms:</span></li>
                                    <li><span>Spare Parts:</span></li>
                                </ul>
                            </el-tab-pane>
                        </el-tabs>
                    </div>
                    <!-- [ Info ] end -->

                </div>
                <!-- [Tree info] end -->

            </div>
        </div>
    </div>

</template>

<script>
    // import Header from '@/components/Header.vue'
    // import Menu from '@/components/Menu.vue'
    export default {
        name: 'company',
        components: {
            // Header,
            // Menu
        },
        data() {
            return {
                companyNameSelect: '',

                loading: false,
                open: false
            }
        },
        methods: {
            showMenu() {
                this.open = true
                console.log('---', this.open);
            },
            hideMenu() {
                this.open = false
                console.log('---', this.open);
            },
            companyName(name) {
                this.companyNameSelect = name
            },
        },
    }
</script>

<style lang="scss" scoped>
    a{
        color:#fff;
    }
    .company {
        height: 100vh;
    }

    .content {
        display: flex;
        height: 100vh;
        padding-top: 50px;
    }

    // [ Wrapper ] start
    .wrap {
        display: flex;
        width: 100%;
        padding: 20px 10px 0 10px;

        &__tree {
            width: 35%;
            padding: 0 10px 10px 0;
            border-right: 1px solid #ccc;
        }
        &__info {
            display: flex;
            flex-direction: column;
            width: 65%;
            padding: 0 0 10px 10px;
        }
        &__info-tab {
            height: 50%;
            ul {
                margin: 0;
                padding: 0;
                list-style: none;
                li {
                    margin-bottom: 8px;
                    span {
                        font-weight: 500;
                        color: #909399;
                    }
                }
            }
        }
        &__person {
            height: 50%;
        }
    }
    // [ Wrapper ] end
</style>

<style lang="less" scoped>
    .nav-tree{
        display:flex;
        flex-direction:column;
        &__item{
            margin:5px 0;
        }
    }
</style>

